export enum PayrollFrequency {
  BiWeekly = 'BiWeekly',
  Monthly = 'Monthly',
  Weekly = 'Weekly',
}
